import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
    baseURL: process.env.BASE_API + '/supplier',
    timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
    if (store.getters.token) {
        config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        console.log(response)
        if(response.headers['refresh-token'] && response.headers['refresh-token'].length > 0){
            let tokenStr = response.headers['refresh-token'];
            store.dispatch('RefreshToken', tokenStr).then(r => {});
        }
        if (response.config.responseType === 'blob') {
            let blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;

            //获取文件名
            let filename = "结果导出.xls";
            if(response.headers['content-disposition']){
                let split = response.headers['content-disposition'].split('filename=');
                if(split.length > 1){
                    filename = decodeURI(split[1]);
                }
            }
            downloadElement.download = filename; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            return;
        }

        if(res.authenticate === false){
            MessageBox.confirm('你已被登出，请重新登录', '登录态过期', {
                confirmButtonText: '重新登录',
                showCancelButton: false,
                showClose: false,
                closeOnClickModal:false,
                type: 'warning'
            }).then(() => {
                store.dispatch('FedLogOut').then(() => {
                    location.reload() // 为了重新实例化vue-router对象 避免bug
                })
            })
            return Promise.reject(response.data)
        }

        if(res.success === false){
            Message({
                message: res.message,
                type: 'error',
                duration: 3 * 1000
            })
            return Promise.reject('error')
        }else{
            return response.data
        }
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 3 * 1000
        })
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js